import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { DocumentUploadDragger } from '@/components';

export const StyledInstructionBlock = styled.div`
  display: flex;
  width: 100%;
  border-radius: 0.6rem;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: ${COLORS.BLACK_PRIMARY};
  color: ${COLORS.WHITE};
  align-items: flex-start;

  svg {
    margin-right: 0.5rem;
    width: 2.1rem;

    @media screen and ${DEVICES.TABLET_S} {
      width: initial;
    }
  }
`;

export const StyledLink = styled.a`
  &&&& {
    cursor: pointer;
    text-decoration: underline;
    color: ${COLORS.YELLOW_PRIMARY};
  }
`;

export const StyledDragger = styled(DocumentUploadDragger)`
  padding: 0 !important;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('20', '30', 'BOLD')};
  text-align: left;
  color: ${COLORS.BLACK};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('30', '30', 'BOLD')};
  }
`;

export const StyledDivider = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${COLORS.MATTERHORN};
  ${pickThemeFontStyles('15', '22', 'NORMAL')};
  width: 100%;
  gap: 0.5rem;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${COLORS.MATTERHORN};
  }
`;

export const StyledHintBlock = styled.div`
  display: flex;
  border-radius: 0.35rem;
  max-width: 29.625rem;
  max-height: 9.5rem;
  flex-direction: column;
  margin-top: 2rem;
  gap: 0.5rem;
  padding: 1rem 0.75rem;
  color: ${COLORS.WHITE};
  background: linear-gradient(90deg, #0c223a 0%, #1d466b 100%);
`;

export const StyledHintTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledHintIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1.25rem;
    height: 1.25rem;

    path {
      fill: ${COLORS.RED};
    }

    @media screen and ${DEVICES.LAPTOP_S} {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;

export const StyledHintTitle = styled.div`
  ${pickThemeFontStyles('18', '22', 'NORMAL')};
`;

export const StyledHintText = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
`;

export const StyledExportProgress = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
  color: ${COLORS.MATTERHORN};
  ${pickThemeFontStyles('14', '22', 'NORMAL')};

  .ant-progress {
    margin: 0;
    line-height: 1;
  }
`;
